import { useGlobal } from '~/hooks/useGlobal';

import { SkeletonCD } from './CheckoutSkeletonCD';
import styles from './CheckoutSkeletonCD.module.scss';

const DeliveryTimeSkeleton = () => {
  const { isMobile } = useGlobal();

  return (
    <>
      <div className={styles.expressDelivery}>
        {!isMobile && <SkeletonCD className={styles.icon} />}
      </div>
      <div className={styles.deliveryTime}>
        {!isMobile && (
          <div>
            <SkeletonCD className={styles.icon} />
          </div>
        )}
        <div className={styles.cardList}>
          {new Array(isMobile ? 4 : 6).fill(0).map((_, index) => (
            <SkeletonCD className={styles.card} key={index} />
          ))}
        </div>
      </div>
    </>
  );
};

export default DeliveryTimeSkeleton;
